Flup.click("show", function(flup, $elm, value, e){
   e.preventDefault();
   var f = $elm.data("fade") ? "fadeIn" : "show";
   $(value)[f]($elm.data("fade"));
});

Flup.click("hide", function(flup, $elm, value, e){
   e.preventDefault();
   var f = $elm.data("fade") ? "fadeOut" : "hide";
   $(value)[f]($elm.data("fade"));
});

Flup.click("toggle", function(flup, $elm, value, e){
   e.preventDefault();
   var f = $elm.data("fade") ? "fadeToggle" : "toggle";
   $(value)[f]($elm.data("fade"));
});

Flup.click("input-val", function(flup, $elm, value, e){
   e.preventDefault();
   var spl = value.split("|");
   $(spl[0]).val(spl[1]);
});

Flup.on("change", "checked-toggle", function(flup, $elm, value, e){
   e && e.preventDefault();
   $(value).toggle($elm[0].checked);
}, true);

Flup.click("toggle-class", function(flup, $elm, value, e){
   e.preventDefault();
   $(value).toggleClass($elm.data("class"));
});

Flup.click("href", function(flup, $elm, value, e){
   e.preventDefault();
   flup("server").location(value);
});
Flup.link("checked-radio-toggle", function(flup, $elm, value){
   var selector = "[name='"+$elm.attr("name")+"']";
   $(selector).change( function(e){
      $(value).toggle( $(selector+":checked").val() == $elm.val() );
   })
   $(selector).change()
})
/*Flup.click("submit-form", function(flup, $elm, value, e){
   e.preventDefault();
   e.stopPropagation();
   $(value).submit();
});*/